<div class="modal fade" id="{{targetId}}" tabindex="-1" #modalDialogEl>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header ">
        <button type="button" class="ba-modal-close" data-bs-dismiss="modal" aria-label="Schließen"
                id="Dialog_Loeschen_Close_Icon" (click)="abbrechenFn()"></button>
        <h1 class="modal-title" id="Dialog_Loeschen_Title">{{title}}</h1>
      </div>
      <div class="modal-body">
        <p id="Dialog_Loeschen_Message">{{message}}</p>
      </div>
      <div class="modal-footer">
        <button
          id="Dialog_Loeschen_Abbrechen_Button"
          type="button"
          class="ba-btn"
          [attr.aria-label]="abbrechenBtnLabel"
          (click)="abbrechenFn()"
          data-bs-dismiss='modal'>
          {{abbrechenBtnLabel}}
        </button>
        <button
          id="Dialog_Loeschen_Loeschen_Button"
          type="button"
          class="ba-btn"
          [attr.aria-label]="loeschenBtnLabel"
          (click)="loeschenFn()"
          data-bs-dismiss='modal'>
          {{loeschenBtnLabel}}
        </button>
      </div>
    </div><!-- /.modal-content -->
  </div><!-- /.modal-dialog -->
</div><!-- /.modal -->
